import { createAsyncThunk } from '@reduxjs/toolkit';
import { FetchRequestHandler } from '../../../utils/commonUtilities';
import { baseUrl } from '../../../constants/Endpoints/EndPoints';

export const fetchFeeScheduleProviderDetails = createAsyncThunk(
  'fetchFeeScheduleProviderDetails', 
  async (practiceId) => {
    const response = await FetchRequestHandler(
      'get', 
      `${baseUrl}api/practices/${practiceId}/providers?view=brief`
    );
    return response.data;
  }
);

export const fetchPreferredNetworks = createAsyncThunk(
  'fetchPreferredNetworks',
  async ({ practiceId, providerId }) => {
    const response = await FetchRequestHandler(
      'get', 
      `${baseUrl}api/practices/${practiceId}/providers/${providerId}/preferred-networks`
    );
    return response.data;
  }
);

export const fetchFeeSchedules = createAsyncThunk(
  'fetchFeeSchedules',
  async ({ practiceId, providerId }) => {
    const response = await FetchRequestHandler(
      'get', 
      `${baseUrl}api/practices/${practiceId}/providers/${providerId}/fee-schedules`
    );
    return response.data;
  }
);

export const fetchFeeScheduleFormDetails = createAsyncThunk(
  "fetchFeeScheduleFormDetails",
  async ({ practiceId, providerId, feeScheduleId }) => {
    const scheduleId = feeScheduleId || "SMFMQYEG16236582";
    const response = await FetchRequestHandler(
      'get',
      `${baseUrl}api/practices/${practiceId}/providers/${providerId}/fee-schedules/${scheduleId}`
    );
    return response.data;
  }
);

